// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2P0eW","name":"styles_name__3OYSf","phone":"styles_phone__pl4wh"};